import React, { FC }              from "react";
import { useStore }               from "react-redux";
import { Table }                  from "semantic-ui-react";
import RecordTemplate             from "../../../../domain/record/template/RecordTemplate";
import RecordTemplates            from "../../../../domain/record/template/RecordTemplates";
import RecordTemplateDeleteButton from "./RecordTemplateDeleteButton";
import RecordTemplateEditButton   from "./RecordTemplateEditButton";

const RecordTemplateList: FC = () => {
  const templates: RecordTemplates = useStore().getState().templates;
  return (
    <>
      {
        templates.isEmpty() ? <p>まだ記録テンプレートが作成されていません。</p> :
          <>
            <Table striped>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>作成済みの記録テンプレート</Table.HeaderCell>
                  <Table.HeaderCell>操作</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {
                  templates.toList().map((template: RecordTemplate) => (
                    <>
                      <Table.Row>
                        <Table.Cell>
                          { template.name.value }
                        </Table.Cell>
                        <Table.Cell>
                          <RecordTemplateEditButton id={ template.id }/>
                          <RecordTemplateDeleteButton recordTemplate={ template }/>
                        </Table.Cell>
                      </Table.Row>
                    </>
                  ))
                }
              </Table.Body>
            </Table>
          </>
      }
    </>
  );
};

export default RecordTemplateList;
